import { Box, Button, List, Popover, Stack, Typography } from '@mui/material';
import { useAcceptInviteMutation } from 'src/api/v1/project-ApiSlice';
import { useGetProjectNotificationsQuery } from 'src/api/v2/project-v2-ApiSlice';
import { ts } from 'src/utils/translate';
import { AcceptInviteRequest } from 'src/model/api/accept-invite-request.model';
import { GetProjectNotificationsResponseItem } from 'src/model/api/get-project-notifications-response.model';
import { useAppDispatch } from 'src/app/hooks';
import { showSnackBar } from 'src/api/ui-slice';
import { NotificationRow } from "src/components/AppHeader/Notifications/NotificationsRow";
import { theme } from "src/theme/mui-theme";

export function NotificationsPopup(props: {
    anchorEl: HTMLElement | null,
    handleClose: () => void
}) {
  const projectNotificationsResult = useGetProjectNotificationsQuery(undefined)
  const open = Boolean(props.anchorEl);
  const [acceptInvite] = useAcceptInviteMutation();
  const dispatch = useAppDispatch();

  async function onAcceptAllClick() {
    if (projectNotificationsResult.data != null) {

      for (let notification of projectNotificationsResult.data.notifications) {
        await acceptInvite({project_id: notification.projectId, role_id: notification.roleId} as AcceptInviteRequest).unwrap();
      }
      dispatch(showSnackBar({ text: ts('role_accept_successful', 'Role accept succesful'), severity: 'info'}));
    }
  }

  if (projectNotificationsResult.data != null) {
    const notifications = projectNotificationsResult.data.notifications
    return (
        <Popover
            id='notifications-popup'
            open={open}
            anchorEl={props.anchorEl}
            onClose={props.handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
        >
          <Box sx={{width: '420px', height: '500px'}}>
              <Stack
                direction="row"
                justifyContent="space-between"
                paddingX="6px"
                paddingTop="6px"
              >
                  <Typography variant='h5' fontWeight="500">
                      Notifications
                  </Typography>

                  <Button
                      disableRipple
                      disableElevation
                      disabled={notifications.length === 0}
                      sx={{
                          textDecoration: "underline",
                          color: notifications.length === 0 ? "grey.500" : theme.palette.primary.main,
                          "&:hover": {
                              backgroundColor: "transparent",
                              textDecoration: "underline",
                          },
                      }}
                      onClick={onAcceptAllClick}
                  >
                      <Typography variant="caption">
                          {ts("mark_all_as_read", "Mark all as read")}
                      </Typography>
                  </Button>
              </Stack>

              {notifications.length > 0 ? (
                  <List sx={{ mt: 1 }}>
                      {notifications.map((notification: GetProjectNotificationsResponseItem, index: number) => (
                          <Box
                              key={notification.projectId}
                              sx={{
                                  position: 'relative',
                                  '&::after': index < notifications.length - 1 ? {
                                      content: '""',
                                      display: 'block',
                                      width: '85%',
                                      height: '1px',
                                      backgroundColor: '#e0e0e0',
                                      margin: '0 auto',
                                  } : {},
                              }}
                          >
                              <NotificationRow notification={notification} />
                          </Box>
                      ))}
                  </List>
              ) : (
                  <Box
                      sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 4,
                          height: "250px",
                      }}
                  >
                      <Typography variant="body1" fontWeight="600">
                          {ts("no_notifications_title", "No notifications to show.")}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                          {ts("no_notifications_description", "You will be notified here once someone invites to join their project.")}
                      </Typography>
                  </Box>
              )}

          </Box>
        </Popover>
    )
  } else {
    return (
        <>
          ...
        </>
    )
  }
}